module.exports = __webpack_public_path__ + "static/media/1007020.9623c868.jpg";